import React, { useState, useEffect, useContext } from "react";

import { AuthContext } from "../../contexts/auth";
import { useNavigate, useParams } from "react-router-dom";



import { permite_acesso, lista_alunos } from "../../services/api";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import './listaAlunos.css'

// import { Row, Form, Button, Container, Tab, Tabs, Table, Col } from "react-bootstrap";

import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Table from "react-bootstrap/Table";
import Col from "react-bootstrap/esm/Col";
import { keyboard } from "@testing-library/user-event/dist/keyboard";
import Accordion from 'react-bootstrap/Accordion';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';

const schema = yup.object({}).required();

const BoletimPlus = (props) => {
    let { cod_unidade } = useParams();

    //let cod_unidade = props.un;

    const logado = JSON.parse(localStorage.getItem("user"));

    const perfil = JSON.parse(localStorage.getItem("perfil"));

    const { authenticated, logout } = useContext(AuthContext);
    const navigate = useNavigate();

    const emaillogado = logado[0].email;


    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];


    localStorage.removeItem("matricula");
    localStorage.removeItem("foto64");

    const handleLogout = () => {
        logout();
    };

    const [alunos, setalunos] = useState([{ id: 0, nome: "Vazio", turma: "", matricula: "" }]);
    const [pessoa, setPessoa] = useState([]);
    const [filtro, setFiltro] = useState('');

    useEffect(() => {
        (async () => {

            const resultado1 = await lista_alunos(cod_unidade);
            setalunos(resultado1.data);

            console.log('resultado1', resultado1.data)
        })();
    }, []);


    function createitem(item) {
        return (
            <tr key={item.matricula}>
                <td><a href={`${process.env.REACT_APP_FRONTEND}/boletimplusAluno/${item.matricula}`}> Boletim Plus </a>  </td>
                <td>{item.nome} </td>
                <td>{item.matricula}</td>
                <td>{item.tur}</td>
            </tr>
        );
    }

    const filtrarAlunos2 = () => {
        return alunos.filter((alunos) => {
            const { matricula, nome, tur } = alunos;
            const termoFiltro = filtro.toLowerCase();

            return (
                nome.toLowerCase().includes(termoFiltro) ||
                matricula.toLowerCase().includes(termoFiltro) ||
                tur.toLowerCase().includes(termoFiltro)
            );
        });
    };

    const Experiment = (Nperfil) => {
        if (Nperfil === "GESTOR")
            return (
                <>
                    <NavDropdown.Item href="/unidade/10">Barra da Tijuca</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/01">Bento Ribeiro</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/11">Campo Grande</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/04">Cascadura</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/16">Freguesia</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/15">Ilha do Governador</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/02">Madureira</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/14">Maricá</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/06">Nilópolis</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/17">Recreio</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/03">Santa Cruz</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/09">Seropédica</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/05">Taquara</NavDropdown.Item>

                </>
            );
        if (Nperfil.startsWith("DIRETOR")) {
            var numerosString = Nperfil.replace("DIRETOR", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });

            return (codigoDinamico)
        };
        if (Nperfil.startsWith("SECRETARIA")) {
            var numerosString = Nperfil.replace("SECRETARIA", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });

            return (codigoDinamico)
        };
    }

    if (typeof alunos !== 'undefined') {
        return (
            <div className="listaPessoa">

                <div className="sticky-top painel">

                    <Navbar expand="lg" className="bg-body-tertiary">

                        <Navbar.Brand href="/">
                            <img
                                src="/novo-logo.png"
                                alt="Santa Mônica Rede de Ensino"
                                style={{ width: "40px", height: "40px", marginRight: "10px" }}
                            />
                            <span style={{ color: "#006cb5", fontFamily: "inherit", fontWeight: "bold" }}>Santa Mônica Rede de Ensino</span>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">

                            <NavDropdown
                                title="UNIDADES"
                            >
                                {Experiment(perfil[0].perfil)}

                            </NavDropdown>

                            <Nav.Link href={`${process.env.REACT_APP_FRONTEND}/ranking`}>RANKING DE ALUNOS</Nav.Link>
                        </Navbar.Collapse>
                    </Navbar>


                </div>
                <center>
                    <h1 style={{ color: "#006cb5", fontFamily: "inherit", fontWeight: "bold" }}> Boletim Plus  - {unidades[parseInt(cod_unidade)]}</h1>
                    <h5>
                        O Boletim Plus é uma ferramenta que permite supervisão acompanhar o desempenho escolar de forma prática e eficiente. <br />
                        Com ele, é possível visualizar as notas do aluno e comparar com a turma e com a mesma série na Rede Santa Mônica. <br />
                    </h5>
                </center>
                <Row className="h7usuario">
                    <h6><center>

                        Utilize o campo abaixo para procurar por nome ou turma ou matricula do aluno desejado. <br />
                    </center>
                    </h6>
                    <center>

                        <input
                            type="text"
                            placeholder="Filtrar alunos"
                            value={filtro}
                            onChange={(e) => setFiltro(e.target.value)}
                            style={{ width: "80%" }}
                        />
                    </center>
                </Row>


                <div className="listapessoa2">
                    <Table striped className="tablePessoas">
                        <thead>
                            <tr>
                                <th>Ação</th>
                                <th>Nome</th>
                                <th>Matricula</th>
                                <th>Turma</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* {pessoa.map(createitem)} */}
                            {/* {alunos.map(createitem)} */}
                            {filtrarAlunos2().map(createitem)}
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    };
};


export default BoletimPlus;